import styled from '@emotion/styled'
import { InfoExtraSmall600Style } from '../../../../../styles/Text.styles'
import theme from '../../../../../styles/theme'
import { RowTitle } from './ParametersForm.styles'

// Extra small label for date range indicators
export const DateRangeLabel = styled.div`
  ${InfoExtraSmall600Style}
  color: ${theme.colors.veryVeryFadedText};
  display: flex;
  margin-top: 1.5rem;
`

export const OrDivider = styled.div`
  font-style: italic;
  font-weight: 300;
  color: #666;
  margin-top: 1.5rem;
  margin-left: 1.5rem;
`

export const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 100%;
`

export const CombinedRowTitle = styled(RowTitle)`
  display: flex;
  align-items: end;

  span {
    padding: 0.625rem;
  }
`
